
import { Helmet } from "react-helmet";

const ArabicPrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-8" dir="rtl">
      <Helmet>
        <title>سياسة الخصوصية - Lainasampo.fi</title>
        <meta name="description" content="سياسة الخصوصية لخدمة مقارنة القروض Lainasampo.fi" />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">سياسة الخصوصية</h1>
        
        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-4">
            هذه ترجمة لسياسة الخصوصية الفنلندية الخاصة بنا. النسخة الفنلندية هي النسخة الملزمة قانونًا.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. مراقب البيانات</h2>
          <p>
            شركة Pulaton Oy هي المسؤولة عن خصوصية خدمة Lainasampo.fi.
            <br />
            رقم الأعمال: 3308199-4
            <br />
            البريد الإلكتروني: asiakaspalvelu@lainasampo.fi
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. المعلومات المجمعة</h2>
          <p>
            نجمع المعلومات التالية من المستخدمين لمعالجة عروض القروض:
          </p>
          <ul className="list-disc pr-5 mb-4 mr-5 text-right">
            <li>الاسم وتفاصيل الاتصال (عنوان البريد الإلكتروني ورقم الهاتف)</li>
            <li>معلومات التعريف الشخصية</li>
            <li>معلومات التوظيف والدخل</li>
            <li>المعلومات المتعلقة بالقرض (المبلغ المطلوب والغرض والمدة)</li>
            <li>المعلومات المالية (القروض الحالية والنفقات)</li>
            <li>المعلومات التقنية (عنوان IP ونوع المتصفح ومعلومات الجهاز)</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. استخدام المعلومات</h2>
          <p>
            نستخدم معلوماتك للأغراض التالية:
          </p>
          <ul className="list-disc pr-5 mb-4 mr-5 text-right">
            <li>لمعالجة طلب القرض الخاص بك</li>
            <li>لطلب عروض القروض من مؤسساتنا المالية الشريكة</li>
            <li>للتواصل معك بشأن طلبك</li>
            <li>لتحسين خدمتنا وتجربة المستخدم</li>
            <li>للوفاء بالتزاماتنا القانونية</li>
            <li>للتحليل الإحصائي وتطوير الخدمة</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. الإفصاح عن المعلومات</h2>
          <p>
            نفصح عن معلوماتك إلى:
          </p>
          <ul className="list-disc pr-5 mb-4 mr-5 text-right">
            <li>مؤسساتنا المالية الشريكة لغرض تقديم عروض القروض</li>
            <li>مقدمي الخدمات الذين يساعدوننا في تشغيل موقعنا على الويب وتقديم خدماتنا</li>
            <li>السلطات عندما يقتضي القانون ذلك</li>
          </ul>
          <p>
            لا يتم الإفصاح عن المعلومات لأغراض التسويق دون موافقتك الصريحة.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. أمن البيانات</h2>
          <p>
            نقوم بتنفيذ التدابير التقنية والتنظيمية المناسبة لحماية معلوماتك الشخصية ضد الوصول 
            غير المصرح به والإفصاح والتعديل والتدمير.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. تخزين البيانات</h2>
          <p>
            نقوم بتخزين معلوماتك طالما كان ذلك ضروريًا لتحقيق الأغراض التي تم جمعها من أجلها، 
            للامتثال للالتزامات القانونية، أو لحماية مصالحنا المشروعة.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. حقوقك</h2>
          <p>
            لديك الحق في:
          </p>
          <ul className="list-disc pr-5 mb-4 mr-5 text-right">
            <li>الوصول إلى بياناتك الشخصية</li>
            <li>تصحيح البيانات الشخصية غير الدقيقة</li>
            <li>طلب حذف بياناتك الشخصية</li>
            <li>تقييد أو الاعتراض على معالجة بياناتك الشخصية</li>
            <li>نقل البيانات</li>
            <li>سحب موافقتك في أي وقت</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. معلومات الاتصال</h2>
          <p>
            إذا كانت لديك أي أسئلة حول سياسة الخصوصية الخاصة بنا أو كيفية تعاملنا مع بياناتك الشخصية، 
            يرجى الاتصال بنا على:
            <br />
            البريد الإلكتروني: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>
    </div>
  );
};

export default ArabicPrivacyPage;
